import classNames from "classnames";
import React from "react";
import UnstyledButton from "src/ui/components/Buttons/UnstyledButton/UnstyledButton";
import "./FilterButton.scss";

interface IFilterButtonProps<T extends string | number> {
    value: T;
    isActive: boolean;
    onClick: (value: T) => void;
    label: string;
    count?: number;
    className?: string;
}

// Faceted-list filter chip used by Studio's Applications view, MainHeaderSearch, etc.
// Active = filled dark pill with a circular count badge; inactive = label + grey circular
// count badge on a transparent background.
function FilterButton<T extends string | number>({
    value,
    isActive,
    onClick,
    label,
    count,
    className,
}: IFilterButtonProps<T>) {
    return (
        <UnstyledButton
            className={classNames(
                "FilterButton",
                { "FilterButton-active": isActive },
                className,
            )}
            onClick={onClick}
            onClickData={value}
        >
            <span className="FilterButton-label">{label}</span>
            {count !== undefined && (
                <span className="FilterButton-count">{count}</span>
            )}
        </UnstyledButton>
    );
}

export default FilterButton;
